import React from "react";
import { motion } from "framer-motion";
import { hideAnimation, coursesAnimation } from "../animate";
import { useScroll } from "./useScroll";
import useWindowDimensions from "./useDimension";

const CoursesDetail5 = (props) => {
  const { width } = useWindowDimensions();
  const [element, controls] = useScroll(width < 1000 ? 0 : 0.25);

  return (
    <div className="details">
      <motion.div
        className="desc"
        variants={coursesAnimation}
        initial="hidden"
        animate={controls}
        ref={element}
      >
        <div style={{ overflow: "hidden" }}>
          <motion.h5 variants={hideAnimation}>
            <span style={{ textDecoration: "underline" }}>
              完成這堂課之後，你能:
            </span>
          </motion.h5>
        </div>
        <ol>
          <li>
            使用<span>Geogebra</span>輔助空間向量的概念。
          </li>
          <li>機器學習中的降維演算法 - 主成分分析(PCA)</li>
          <li>矩陣的奇異值分解 (Singular Value Decomposition)</li>
          <li>判斷可逆矩陣的性質與線性獨立的集合。</li>
          <li>
            理解電腦圖形的處理與矩陣，設計對二維與三維圖形做變換的相對應矩陣。
          </li>
          <li>
            對矩陣做拆解，包含
            <span>LU Decomposition, Eigenvalue Decomposition</span>等等。
          </li>
          <li>
            使用
            <span>
              Power Method, Shifted Inverse Power Method, Gershgorin Circle
              Theorem判斷eigenvalue
            </span>
            的範圍與逼近值。
          </li>
          <li>學習Strassen's Algorithm。</li>
          <li>
            了解向量的<span>空間投影、Grand-Schmidt Process、最小平方法</span>
            在多項式函數的應用。
          </li>
        </ol>

        <br />

        <div style={{ overflow: "hidden" }}>
          <motion.h5 variants={hideAnimation}>
            <span style={{ textDecoration: "underline" }}>這堂課是設計給:</span>
          </motion.h5>
        </div>
        <ol>
          <li>對資料科學有興趣的開發工程師</li>
          <li>正在大學就讀資訊工程、電腦科學、資料科學、理工科、數學的學生</li>
          <li>對於演算法有興趣者</li>
          <li>想要學習資料結構與演算法的人</li>
          <li>想要轉職成為工程師的人</li>
          <li>不是資工本科系，但想要就讀或報考資工研究所的學生。</li>
        </ol>
      </motion.div>
      <div className="images">
        <img src={props.img} alt="" />
      </div>
    </div>
  );
};

export default CoursesDetail5;
